import { InputGroup } from "@blueprintjs/core";
import { ContextMenu2 } from "@blueprintjs/popover2";
import React, { useState } from "react";

import { DeleteSeriesModal } from "../../../components/DeleteSeriesModal/delete-series-modal";
import { PlayPropertyContextMenu } from "../../../components/play-property-context-menu/play-property-context-menu";
import { Series, useDeleteSeriesMutation, useEditSeriesMutation } from "../../../redux/slices/series-api";
import styles from "./series.tab.module.scss";

interface SeriesItemProps {
  series: Series;
  onClick: () => void;
}

export const SeriesItem = ({ series, onClick }: SeriesItemProps) => {
  const [editingText, setEditingText] = useState(false);
  const [newName, setNewName] = useState("");
  const [editSeries] = useEditSeriesMutation();

  const reset = () => {
    setEditingText(false);
    setNewName("");
  };

  const handleSubmitNewName = () => {
    if (!newName || newName === series.name) {
      reset();
      return;
    }

    editSeries({ id: series.id, series_id: series.series_id, name: newName });
    reset();
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      handleSubmitNewName();
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteSeries] = useDeleteSeriesMutation();

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteSeries = (e: any) => {
    e.stopPropagation();
    setShowDeleteModal(false);
    deleteSeries({ id: series.series_id });
  };

  const handleEditClick = () => {
    setEditingText(true);
  };

  return (
    <ContextMenu2
      key={series.id}
      content={<PlayPropertyContextMenu playProperty="Series" onDelete={handleDeleteClick} onEdit={handleEditClick} />}
    >
      <div className={styles.seriesItem} onClick={onClick}>
        <div className={styles.seriesNameContainer}>
          <div>
            {editingText ? (
              <InputGroup
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder={series.name}
                leftIcon="edit"
                onClick={(e) => e.stopPropagation()}
                onKeyDown={handleKeyDown}
                onBlur={handleSubmitNewName}
                autoFocus
              />
            ) : (
              series.name
            )}
          </div>
        </div>
        <div className={styles.seriesInfoEditContainer}>
          <div className={styles.playsNumber}>{series.noOfPlays}</div>
        </div>
      </div>
      <DeleteSeriesModal
        show={showDeleteModal}
        handleClose={(e: any) => {
          e.stopPropagation();
          setShowDeleteModal(false);
        }}
        SeriesName={series.name}
        handleDeleteSeries={handleDeleteSeries}
      />
    </ContextMenu2>
  );
};
